import { ResolveFn } from '@angular/router';
import { IWeather } from '../interfaces/IWeather';
import { DashboardService } from '../services/DashboardService';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';

export const weatherResolver: ResolveFn<IWeather> =
  () => inject(DashboardService).getWeather()
    .pipe(map(res => res?.data ?? null));
